import { makeStyles } from "@material-ui/core";
import { ResponsivePie } from '@nivo/pie';
import { DashboardHeader } from "pages/admin/dashboard/components/general";
const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)'
  },
  chart: {
    width: '100%',
    height: '100%',
  }
}));


const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
  let total = 0
  dataWithArc.forEach(datum => {
    total += datum.value
  })

  return (
    <text
      x={centerX}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
      style={{
        fontSize: '25px',
        fontWeight: 600,
      }}
    >
      {total}
    </text>
  )
}

const data = [
  {
    "id": "incountry",
    "label": "ในประเทศ",
    "value": 20,
    "color": "#EDAD3D"
  },
  {
    "id": "outcountry",
    "label": "ต่างประเทศ",
    "value": 80,
    "color": "#1BA0B2"
  },
  {
    "id": "unsuccessful",
    "label": "ยังไม่ได้ตรวจลงตรา",
    "value": 40,
    "color": "hsl(203, 78%, 60%)"
  }
]

const VisaPieChart = ({ data /* see data tab */ }) => (
  <ResponsivePie
    data={data}
    margin={{ top: 10, right: 20, bottom: 20, left: -50 }}
    innerRadius={0.7}
    borderColor={{ from: 'color', modifiers: [['darker', '0.2']] }}
    padAngle={1}
    enableArcLinkLabels={false}
    arcLinkLabelsSkipAngle={11}
    arcLinkLabelsTextColor="#333333"
    arcLinkLabelsThickness={2}
    arcLinkLabelsColor={{ from: 'color', modifiers: [] }}
    arcLabelsRadiusOffset={0.45}
    arcLabelsTextColor={{ from: 'color', modifiers: [['brighter', '3']] }}
    colors={data.map(x => x.color)}
    layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', CenteredMetric]}
    legends={[
      {
        anchor: 'right',
        direction: 'column',
        justify: false,
        translateX: 0,
        translateY: -2,
        itemsSpacing: 0,
        itemWidth: 103,
        itemHeight: 20,
        itemTextColor: '#999',
        itemDirection: 'left-to-right',
        itemOpacity: 1,
        symbolSize: 17,
        symbolShape: 'circle',
        effects: [
          {
            on: 'hover',
            style: {
              itemTextColor: '#000'
            }
          }
        ]
      }
    ]}


  />)

function VisaChart() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="การตรวจลงตรา" />
      </div>
      <div className={classes.wrapChart}>

        <VisaPieChart data={data} className={classes.chart} />
      </div>
    </>
  )
}


export default VisaChart;